import { Box, DrawerCloseButton } from '@chakra-ui/react';
import AppText from 'voxguru-v1/components/Typography/AppText';
import appColors from 'voxguru-v1/theme/appColors';
import AppFlex from 'voxguru-v1/components/chakraLayoutOverrides/AppFlex';
import RenderIf from 'voxguru-v1/components/RenderIf/RenderIf';
import { fontSizes } from 'voxguru-v1/theme/fonts';

function ProgramDrawableHeader({ programModule, programTitle, moduleName }) {
  return (
    <AppFlex variant="programDrawableHeader">
      <Box>
        <AppFlex customStyles={{ alignItems: 'center' }}>
          <RenderIf isTrue={moduleName}>
            <AppText
              title={moduleName}
              variant="orangeXXS"
              customStyles={{ fontSize: fontSizes.xs }}
            />
            <AppText title="/" customStyles={{ mx: 1 }} variant="lightXS" />
          </RenderIf>
          <AppText title={programModule} variant="lightXS" />
        </AppFlex>
        <AppText title={programTitle} size="md" />
      </Box>
      <Box>
        <DrawerCloseButton color={appColors.brandGrey['300']} />
      </Box>
    </AppFlex>
  );
}

export default ProgramDrawableHeader;
